import { gql } from '@apollo/client'
import employeeTagInfoShortFragment from '../ranking/fragments/employeeTagInfoShortFragment'

export const REMOVE_EMPLOYEE_TAG = gql`
  mutation RemoveEmployeeTag($removeEmployeeTagInput: RemoveEmployeeTagInput!) {
    removeEmployeeTag(removeEmployeeTagInput: $removeEmployeeTagInput) {
      ...EmployeeTagInfoShort
    }
  }

  ${employeeTagInfoShortFragment}
`

export const ADD_EMPLOYEE_TAG = gql`
  mutation AddEmployeeTag($employeeId: HashedId!, $type: EmployeeTagType!) {
    addEmployeeTag(employeeId: $employeeId, type: $type) {
      ...EmployeeTagInfoShort
    }
  }

  ${employeeTagInfoShortFragment}
`

export const ADD_ENTRY_LEVEL_LOW_TAG = gql`
  mutation AddEntryLevelLowTag($employeeId: HashedId!) {
    addEntryLevelLowTag(employeeId: $employeeId) {
      ...EmployeeTagInfoShort
    }
  }

  ${employeeTagInfoShortFragment}
`
